import { TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { HeadCell } from '@common/components/Table/table.types'
import { SubjectStudyTimepoint, TimepointSubject } from '@common/config/api/client'

export default function DefaultSubjectTableHeader({ studyTimepoints }: { studyTimepoints: SubjectStudyTimepoint[] }) {
  const headCells: readonly HeadCell<TimepointSubject>[] = [
    { disablePadding: false, id: 'pseudo_id', label: 'Subject', disableSort: false, stickyColumn: true, width: 200 },
    {
      disablePadding: false,
      id: 'blind_code',
      label: 'Blind Code',
      disableSort: false,
      stickyColumn: true,
      width: 120,
    },
    {
      disablePadding: false,
      id: 'site_id' as keyof TimepointSubject,
      label: 'Site ID',
      disableSort: false,
      stickyColumn: true,
      width: 120,
    },
    { disablePadding: false, id: 'status', label: 'Status', disableSort: false, stickyColumn: true, width: 120 },
    {
      disablePadding: false,
      id: 'query' as keyof TimepointSubject,
      label: 'Query',
      disableSort: false,
      stickyColumn: true,
      width: 120,
    },
    ...(studyTimepoints || []).map((tp) => ({
      disablePadding: false,
      id: tp.timepoint_id as keyof TimepointSubject,
      label: tp.name,
      disableSort: true,
      minWidth: 220,
    })),
  ]

  // Calculate the left position for sticky columns
  const getStickyLeft = (index: number) => {
    let left = 48 // Start after the checkbox column
    for (let i = 0; i < index; i++) {
      if (headCells[i].stickyColumn && headCells[i].width) {
        left += headCells[i].width!
      }
    }
    return left
  }

  return (
    <TableHead
      sx={{
        visibility: 'collapse',
      }}
      data-testid="default-subject-table-header"
    >
      <TableRow data-testid="header-row">
        <TableCell
          padding="checkbox"
          sx={{
            minWidth: 48,
            width: 48,
          }}
          data-testid="header-checkbox-cell"
        />
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            data-testid={`head-table-cell-${index}`}
            sx={{
              width: headCell.width ? headCell.width : 'auto',
              minWidth: headCell.minWidth ? headCell.minWidth : 'auto',
              zIndex: headCell.stickyColumn ? 2 : 'auto',
              left: headCell.stickyColumn ? getStickyLeft(index) : 'auto',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            <Typography
              noWrap
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {' '}
              {headCell.label}{' '}
            </Typography>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}
